import { useQuery } from '@tanstack/react-query';
import { sms } from '@repletoryreach/sdk-api';

/**
 * Whether SMS exists for this account, asked once and shared.
 *
 * SMS goes through a provider the platform chooses (4 October 2026). Until one
 * is set up, the console shows nothing of it: no settings page, no consent
 * control on a contact, no import column. Anything short of a clear yes (a
 * failed request, a service that is not deployed, an answer that says off)
 * counts as no, the same rule as Voice.
 */
export function useSmsStatus() {
  const q = useQuery({
    queryKey: ['sms-status'],
    queryFn: () => sms.getStatus(),
    staleTime: 60_000,
    retry: false
  });
  const status = q.data?.data ?? null;
  return { status, available: status?.available === true, isPending: q.isPending, refetch: q.refetch };
}
